import {
  Enum
} from '@/base/Enum';
export class identityEnum extends Enum {
  constructor() {
    super();
  }
  //主管部门用户
  主管部门用户 = '业务领导'
  局长 = '物业市局领导'
  维修资金部门领导 = '物业区领导'
  维修资金业务主管 = '物业区领导'
  维修资金业务经办 = '业务领导'
  维修资金账务主管 = '物业区领导'
  维修资金账务经办 = '业务领导'
  维修资金窗口 = '受理员'
  // 物业管理部门领导 = '物业市局领导'
  // 物业管理部门业务主管 = '物业区领导'
  // 物业管理部门业务经办 = '业务领导'

  // 以后修改为专门的名称
  物业管理部门领导 = '物业市局部门领导'
  物业管理部门业务主管 = '物业市局领导'
  物业管理部门业务经办 = '物业市局工作人员'
  物业管理部门窗口 = '物业市局受理员'

  区局物业管理部门领导 = '物业区局部门领导'
  区局物业管理部门业务主管 = '物业区局领导'
  区局物业管理部门业务经办 = '物业区局工作人员'
  区局物业管理部门窗口 = '物业区局受理员'

  街道办用户 = '街道办'
  街道办主任 = '街道办'
  街道办业务经办 = '街道办'

  居委会用户 = '居委会'
  居委会主任 = '居委会'
  居委会业务经办 = '居委会'
  //开发建设单位用户
  开发建设单位用户 = '开发商'
  开发建设单位管理员 = '开发商'
  开发建设单位业务经办 = '开发商'
  // 物业服务企业用户
  物业服务企业用户 = '企业人员'
  物业服务企业管理员 = '企业人员'
  物业服务企业项目经理 = '项目经理'
  物业服务企业工程人员 = '工程人员'
  物业服务企业日常管理人员 = '日常管理员'
  物业服务企业业务经办 = '企业人员'
  // 业委会用户
  业委会用户 = '业委会'
  业委会主任 = '业委会'
  业委会成员 = '业委会'
  //审价机构用户
  审价机构用户 = '暂无'
  // 六、银行用户
  银行用户 = '暂无'
  //七、审计机构用户
  审计机构用户 = '暂无'
  审计机构业务经办 = '暂无'
  //审价机构业务经办
  审价机构业务经办 = '暂无'
  // 九、业主
  业主 = '暂无'
  //业主代表
  业主代表 = '暂无'
  //施工单位用户
  施工单位用户 = '暂无'
  //十二、系统管理员
  系统管理员 = '系统管理员'
}